import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: '最新动态', href: '#updates' },
    { label: '热门话题', href: '#topics' },
    { label: '深度扒文', href: '#cards' },
    { label: '焦点专题', href: '#carousel' },
    { label: '联系我们', href: '#contact' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-100/95 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.3)]' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a href="#" className="flex items-center gap-2 flex-shrink-0">
            <span className="text-lg md:text-xl font-heading text-primary-400 whitespace-nowrap">51cg吃瓜</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            <a href="#" className="px-3 py-2 text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap rounded-lg hover:bg-background-200/60">首页</a>
            {navItems.map((item) => (
              <a key={item.href} href={item.href} className="px-3 py-2 text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap rounded-lg hover:bg-background-200/60">{item.label}</a>
            ))}
          </nav>

          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-md border-t border-background-200/60">
          <nav className="flex flex-col px-4 py-3 gap-1">
            <a href="#" onClick={() => setMobileOpen(false)} className="px-3 py-2.5 text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap rounded-lg">首页</a>
            {navItems.map((item) => (
              <a key={item.href} href={item.href} onClick={() => setMobileOpen(false)} className="px-3 py-2.5 text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap rounded-lg">{item.label}</a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}